import { EditItem, IEditItem } from "ui/Scripts/source/models/common/editItem";
import { TaskStateEditabilityType } from "ui/Scripts/source/models/enums";

export interface ITaskEditItemTaskState extends IEditItem {
    code: string;
    color: string;
    sortOrder: number;
    editabilityType: TaskStateEditabilityType;
}

export class TaskEditItemTaskState extends EditItem implements ITaskEditItemTaskState {
    code: string;
    color: string;
    sortOrder: number;
    editabilityType: TaskStateEditabilityType;

    constructor();
    constructor(obj: ITaskEditItemTaskState);
    constructor(obj?: any) {
        super(obj);
        this.code = obj && obj.code || "";
        this.color = obj && obj.color || "";
        this.sortOrder = obj && obj.sortOrder || 0;
        this.editabilityType = obj && obj.editabilityType || TaskStateEditabilityType.NoLimitation;
    }
}